import * as types from './actionTypes';  
import offeringApi from '../api/offeringApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';

export function doOffering(data) {

  return {
    type: types.DO_OFFERING, 
    data
  };
}

export function doOfferingRes(data) {  
  return {
    type: types.DO_OFFERING_RES, 
    data
  };
}

export function get_offering(data) {
  const TOKEN = getItem('auth_token');
  if(TOKEN){
    return function(dispatch) {
      offeringApi.doOffering(data).then(data => {
        dispatch(doOfferingRes(data));
        dispatch(doOfferingRes(null));
      }).catch(error => {
        return error
      });
    };
  }else{
    logout()
  }
}

